    <div class="ha-sayfa">

      <!-- ═══ BAŞLIK BANDI ═══ -->
      <header class="ha-baslik">
        <button class="ha-geri" [routerLink]="['/', '🧩', '📟', 'pano']">
          <span nz-icon nzType="arrow-left" nzTheme="outline"></span>
        </button>
        <div class="ha-baslik-bilgi">
          <h1 class="ha-baslik-yazi">HMI Yapılandırma</h1>
          <span class="ha-baslik-alt">Tüm cihaz ayarları parametre sistemiyle yönetilir</span>
        </div>
        <div class="ha-baslik-aksiyonlar">
          <nz-tag nzColor="blue">
            <span nz-icon nzType="setting" nzTheme="outline"></span>
            {{ toplamParametreSayisi }} parametre
          </nz-tag>
          <button nz-button nzType="default" nzSize="small" (click)="disaAktar()">
            <span nz-icon nzType="download" nzTheme="outline"></span>
            Dışa Aktar
          </button>
        </div>
      </header>

      <!-- ═══ SEKME YAPISI ═══ -->
      <nz-tabs nzType="card" nzSize="small" class="ha-sekmeler"
                 [(nzSelectedIndex)]="aktifSekme">
        @for (sekme of sekmeler; track sekme.ismi) {
          <nz-tab [nzTitle]="sekmeTitleTpl">
            <ng-template #sekmeTitleTpl>
              <div class="ha-sekme-baslik">
                <span nz-icon [nzType]="sekme.simge" nzTheme="outline"></span>
                <span>{{ sekme.ismi }}</span>
              </div>
            </ng-template>

            <!-- Her sekme kendi parametre bileşenini render eder -->
            <div class="ha-sekme-icerik">
              <div class="ha-sekme-aciklama">
                <span nz-icon [nzType]="sekme.simge" nzTheme="outline" class="ha-aciklama-ikon"></span>
                {{ sekme.aciklama }}
              </div>

              <fikoyt-parametreler
                [(parametreler)]="sekme.parametreler"
                (parametreDegisti)="parametreDegisti($event, sekme)">
              </fikoyt-parametreler>
            </div>
          </nz-tab>
        }
      </nz-tabs>

      <!-- ═══ ALT AKSİYON BANDI ═══ -->
      <footer class="ha-footer">
        <button nz-button nzType="primary" nzSize="large" class="ha-kaydet-btn"
                (click)="kaydet()">
          <span nz-icon nzType="save" nzTheme="outline"></span>
          Tüm Ayarları Kaydet
        </button>

        <nz-divider nzType="vertical"></nz-divider>

        <button nz-button nzType="default" nzSize="small"
                nz-popconfirm nzPopconfirmTitle="Tüm ayarlar sıfırlanacak. Emin misiniz?"
                (nzOnConfirm)="sifirla()">
          <span nz-icon nzType="undo" nzTheme="outline"></span>
          Varsayılana Dön
        </button>

        <button nz-button nzType="default" nzSize="small" (click)="iceAktar()">
          <span nz-icon nzType="upload" nzTheme="outline"></span>
          İçe Aktar
        </button>
      </footer>

    </div>
